import { useMemo, useState } from 'react';
import { Button } from '../../../components/button';

interface ProfileProgressProps {
  progress: number;
  compact?: boolean;
  className?: string;
}

export const ProfileProgress = ({ compact, className, progress }: ProfileProgressProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const rowClassName = useMemo(
    () => `tw:flex ${compact ? 'tw:flex-col' : 'tw:items-center'}`,
    [compact]
  );
  const colClassName = useMemo(
    () => `profile-progress--count__column ${compact ? 'tw:mb-2' : ''}`,
    [compact]
  );
  const cardClassName = useMemo(
    () =>
      `tw:border tw:border-stoplight-danger/20 tw:rounded-xl tw:bg-stoplight-danger/10 tw:w-full tw:sm:max-w-[50%] tw:lg:max-w-[33%] tw:text-left ${compact ? 'compact tw:p-3' : 'tw:p-3'} ${className ?? ''}`,
    [className, compact]
  );

  const handleClick = (_e: React.MouseEvent) => {
    setIsLoading(true);
    window.location.href = '/app/provider/onboarding';
  };

  return (
    <div className={cardClassName}>
      <div>
        {!compact && (
          <>
            <div className="tw:text-xl tw:mb-2 tw:pr-1">
              <Button
                color="stoplight-danger"
                small
                className="tw:block tw:my-2"
                disabled={isLoading}
                onClick={handleClick}
              >
                {isLoading ? 'Loading...' : 'Finish Onboarding'}
              </Button>
            </div>
            <p className="tw:text-sm profile-progress--text tw:mb-2 tw:pt-1">
              In order to be listed on the Marketplace, you need to complete the onboarding process.
            </p>
          </>
        )}
        <div className={rowClassName}>
          <div className={colClassName}>
            <span className="tw:font-bold tw:text-[14px] tw:mr-2">
              {progress}% {compact && 'complete'}
            </span>
          </div>
          <div className="tw:flex-1">
            <div className="tw:max-w-[260px] tw:w-full tw:rounded-full tw:h-2 tw:bg-zinc-300">
              <div
                className="tw:h-2 tw:rounded-full tw:bg-stoplight-success"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
